import {
	API_ROOT
} from '@/config/env.js'

let request_root = API_ROOT + '/service.php';
let upload_url = request_root;


// 请求参数
let handleRequestParams = function(params = {}) {
	if (params && !params.token) {
		params.token = uni.getStorageSync('token') || '';
		params.userId = uni.getStorageSync('userId') || '';
	}
	return params
}
// 请求参数
let handleRequestParamsByAction = function(params = {}) {
	// if (params.action == 'product_channel') {
	// 	params.uType = uni.getStorageSync('type') || ''
	// } else if (params.action == 'product_plist') {
	// 	params.uType = uni.getStorageSync('type') || ''
	// }
	
	params.uType = uni.getStorageSync('type') || ''
	
	if(!params.token) {
		params.uType =  '';
	}
	
	return params
}

// 接口节流
//需要设置节流的接口 比如表单提交类接口需要限制调用的时间间隔
let apiThrottleList = [
	'bindMoble',
	'updateUser',
];
let apiTimeStackList = []; //接口调用时间记录
// 接口节流
function do_check_request(option) {
	let request_action = option.data.action || ''
	if (apiThrottleList.includes(request_action)) {
		// debugger
		console.log('接口需要节流')
		let ms = new Date().getTime();
		let first_same_item = apiTimeStackList.find(v => v.action == request_action);
		let time_divider = 0;
		if (first_same_item) {
			time_divider = ms - first_same_item.ms
			console.log('time_divider = ', time_divider)
		}

		//如果时间间隔少于300毫秒  结束本次接口调用
		if (time_divider && time_divider < 400) {
			console.log('接口调用间隔少于400毫秒 禁止继续调取数据')
			return false
		} else {
			apiTimeStackList.unshift({
				action: request_action,
				ms: ms,
			});
		}
	}

	return true
}

// 商城接口模版
// this.$api({
// 	url: '/service.php',
// 	method: 'post',
// 	data: {
// 		action: 'index_index',
// 	},
// })
let api = (option) => {
	let request_url = request_root;
	let request_method = 'get' || option.method || 'post';
	let request_data = option.data || {}
	request_data = handleRequestParams(request_data);
	request_data = handleRequestParamsByAction(request_data);

	return new Promise((resolve, reject) => {
		if (!do_check_request(option)) {
			return resolve({
				code: 210
			})
		}

		//请求地址
		uni.request({
			url: request_url,
			method: request_method,
			data: request_data,
			header: {
				'content-type': 'application/x-www-form-urlencoded'
				// 'content-type': 'multipart/form-data'
			},
			dataType: "json",
			success(res) {
				if (1 || (res && res.data && res.data.dev == 1)) {
					console.log('api请求【req】', option)
					try {
						let res_str = JSON.parse(JSON.stringify(res.data))
						console.log('api响应【res】', res_str)
					} catch (error) {

					}
				}
				if (res.statusCode != 200) {
					uni.showToast({
						icon: 'none',
						title: (option.data.action) + ' 接口异常',
						duration: 3000
					});
					return false;
				}
				if (res.data.code === 401) { //用户未登录
					uni.navigateTo({
						url: '/pages/login/login'
					})
				}
				resolve(res.data)
			},
			fail(res) {
				console.log('api调试【fail-res】', res)
			}
		});
	});
}



let apiUpload = (option) => {
	let filePath = option.data.img;
	delete option.data.img
	let formData = handleRequestParams(option.data);

	return new Promise((resolve, reject) => {
		uni.uploadFile({
			url: upload_url,
			filePath: filePath,
			formData: formData,
			name: 'img',
			success: (res) => {
				if (res.statusCode != 200) {
					uni.showToast({
						title: '上传错误',
						duration: 2000
					});
					return false;
				}
				resolve(JSON.parse(res.data))
			},
			fail: (err) => {
				console.log('apiUpload fail', err)
			}
		});
	});
}

export default {
	api,
	apiUpload,
};